import { Component } from '@angular/core';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PendingApplicationsService } from '../pending-applications.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { PendingApplicationDetails } from '../DTOs/pending-application-details';
import { SavePendingAppRequest } from '../DTOs/save-pending-app-request';

@Component({
  selector: 'app-edit-liaison-information-modal',
    templateUrl: './edit-liaison-information-modal.component.html',
    providers: [UIBlockingService]
})
export class EditLiaisonInformationModalComponent {
    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private pendingApplicationService: PendingApplicationsService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    liaisonFirstNameCtrl = new FormControl("liaisonFirstName", [Validators.required]);
    liaisonLastNameCtrl = new FormControl("liaisonLastName", [Validators.required]);
    liaisonEmailCtrl = new FormControl("liaisonEmail", [Validators.required, Validators.email]);
    liaisonPhoneCtrl = new FormControl("liaisonPhone", [Validators.required]);
    liaisonTitleCtrl = new FormControl("liaisonTitle", [Validators.required]);

    manageLiaisonInfoForm: FormGroup = new FormGroup({
        liaisonFirstName: this.liaisonFirstNameCtrl,
        liaisonLastName: this.liaisonLastNameCtrl,
        liaisonEmail: this.liaisonEmailCtrl,
        liaisonPhone: this.liaisonPhoneCtrl,
        liaisonTitle: this.liaisonTitleCtrl,
    });
    app: PendingApplicationDetails;
    validationTriggered = false;
    isBusy = false;

    liaisonFirstName() { return this.manageLiaisonInfoForm.get('liaisonFirstName').value }
    liaisonLastName() { return this.manageLiaisonInfoForm.get('liaisonLastName').value }
    liaisonEmail() { return this.manageLiaisonInfoForm.get('liaisonEmail').value }
    liaisonPhone() { return this.manageLiaisonInfoForm.get('liaisonPhone').value }
    liaisonTitle() { return this.manageLiaisonInfoForm.get('liaisonTitle').value }
    
    ngOnInit() {
        this.resetManageLiaisonForm();
    }
    private resetManageLiaisonForm(): void {
        this.manageLiaisonInfoForm.reset();
        this.manageLiaisonInfoForm.patchValue({
            liaisonFirstName: this.app.liaisonFirstName,
            liaisonLastName: this.app.liaisonLastName,
            liaisonEmail: this.app.liaisonEmail,
            liaisonPhone: this.app.liaisonPhone,
            liaisonTitle: this.app.liaisonTitle,
        })
    }
    dismiss(): void {
        this.activeModal.dismiss();
    }
    saveLiaisonInfo() {
        for (var i in this.manageLiaisonInfoForm.controls) {
            this.manageLiaisonInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageLiaisonInfoForm.valid) return;

        this.blockUI.start();
        var request = new SavePendingAppRequest(
            this.app.appId, this.app.companyName, this.app.employeeCount.value, this.app.businessPhone,
            this.app.businessAddress, this.app.businessCity, this.app.businessState, this.app.businessZip, this.app.minorityCerts?.map(x => x.value),
            this.liaisonFirstName(),
            this.liaisonLastName(),
            this.liaisonEmail(),
            this.liaisonPhone(),
            this.liaisonTitle(),
            this.app.membershipLevel.value, this.app.price, this.app.paymentType, this.app.isAutoRenew
        );

        this.pendingApplicationService.UpdatePendingAppInfo(request)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.blockUI.stop();
                    this.activeModal.close();
                }
            })
    }

}
